import Vue from "vue";
import App from "./App.vue";
import Api from "./utils/Api";
import router from "./router";
import store from "./store";
import Layout from "./layouts/Base-layout";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Object.defineProperty(Vue.prototype, "Api", { value: Api });

Vue.config.productionTip = false;
Vue.component("Layout", Layout);
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// Add Vue-moment for date format
Vue.use(require("vue-moment"));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
